export default {
  routes: {
    home: "Home",
    login: "Login",
    register: "Register",
    logout: "Logout",
    company: "Company",
    user: "Users",
    contact: "Contact",
    userEdit: "Account",
    superadmin: "Admin",
    connectors: "Connectors",

    devices: "Sensors",
    deviceFields: "Sensorfield",
    devicePool: "Sensor pool",
    live: "Live Data",
  },

  landing: {
    or: "OR",
  },

  connector: {
    toolbarTitle: "Connector",
    field: {
      name: "Name",
      path: "URL",
      port: "Port",
      type: "Type",
      active: "Active",
      template: "Setting",
    },
  },

  log: {
    type: {
      sms: "SMS",
      app: "Application",
      warning: "Warning",
      error: "Error",
      userevent: "Userevent",
      login: "Login",
    },

    logTable: {
      title: "Log",
    },

    activeAlarms: {
      title: "Active alarms",
    },

    activeUsersTable: {
      title: "Logged in users",
    },

    fields: {
      type: "Type",
      user: "User",
      message: "Message",
      createdAt: "Created",

      status: "Status",
      lastAction: "Event",
      lastSeen: "Timestamp",

      alarm: {
        name: "Name",
        value: "Value",
        messageSent: "Sent notification",
      },
    },
  },

  common: {
    timestamp: "Timestamp",
    lang: "Language",
    error: "An error occured, -try again later",
    edit: "Edit",
    delete: "Delete",
    purge: "Erase",
    submit: "Send",
    create: "Create",
    update: "Update",
    get: "Get",
    latest: "Latest",
    value: "Value",
    values: "Values",
    amount: "Amount",

    confirmDelete: "Är du säker?",

    search: "Search",
    close: "Close",

    login: "Login",
    register: "Enroll",
    email: "Email",
    password: "Password",
    confirmPassword: "Confim Password",
    newPassword: "New Password",
    forgotPassword: "Forgot Password",

    createdAt: "Created",
    updatedAt: "Updated",

    save: "Save",
    show: "Show",
    updated: "Updated",
    created: "Created",
    deleted: "Erased",
    back: "Return",
    send: "Send",

    add: "Add",

    settings: "Setup",

    noDataFound: "No date found",
    darkTheme: "Dark theme",

    active: "Active",
    notActive: "Not active",

    sent: "Sent",
    notSent: "Not sent",

    loginOrRegister: "Login or enroll",

    copy: "Kopiera",
    verify: "Are you sure you want to continue?",
    disagree: "No",
    accept: "Yes",
    yes: "Yes",
    no: "No",

    or: "Or",

    dashboard: "Go to Dashboard",

    days: {
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday",
    },

    validation: {
      required: "This field is required",
      max: "The field has exceded a max limit",
    },
  },

  device: {
    name: "Sensors",
    serialNumber: "Serial number",
    imei: "Imei",
    productName: "Product Id",
    deviceId: "Sensor Id",
    simIccid: "SimIccId",
    hardwareRevision: "Hardware version",
    firmwareMajor: "Fiemware version major",
    firmwareMinor: "Firmware version minor",
    lastContact: "Last contact",
    secret: "Secret",
    metas: "Meta",

    fields: {
      name: "Sensor field",
      deviceFieldId: "Id",
      label: "New Key",
      key: "Key",
      modifier: "Formula",
      ignore: "Ignore field",
      device: "Sensor",
      template: "Template",
      templateDefault: "Custom",
      ignoreStatus: "Status",
      lastContact: "Last contact",

      dataTableTitle: "Field for sensor",
      addSensorField: "Add new sensor field",

      modifierDescription:
        "Use the character 'V' for the value of the device key. For example 'V/100' will divide the value by 100.",

      actions: "",
    },

    data: {
      lastFive: "Last 5 values",
    },

    pool: {
      toolbar: "Sensor pool",
      name: "Sensor pool",
    },

    meta: {
      title: "Free field",
      keyName: "Name",
      value: "Value",
    },
  },

  live: {
    waiting: "Waiting for sensors to connect...",
    statusOk: "CONNECTED",
    statusNo: "DISCONNECTED",
    title: "Live Data",
  },

  contact: {
    title: "Contact us",
    descriptionTitle: "NB IOTECH",
    description:
      "We now it can be hard to get going, Dont hesitate to contact us and we will help you anser your questions",
    emailTitle: "Email",
    email: "info@nb-iot.se",
    phoneTitle: "Phone",
    phoneOne: "+46 (0) 500 6000 22",
    phoneTwo: "+46 (0) 733 165 100",
    locationSiencepark: "Skövde Science Park",
    locationStreet: "Kaplansgatan 16B",
    locationPostalcode: "521 32 Skövde",
    locationCountry: "Sweden",
  },

  company: {
    name: "Companyname",
    orgNumber: "Org-number",

    companyInfo: "Company information",

    addUser: "Add new user",

    invite: "Invite new user",
    inviteSent: "Invitation sent",
    inviteFailed:
      "Could not find the user, Make sure the user is registrered before!",

    fields: {
      name: "Comany name",
      orgNumber: "Org-nummer",
      postalAdress: "Postal adress",
      deliveryAdress: "Delivery adress",
      contactPhonenumber: "Contact phonenumber",
      invoiceAdress: "Email for contact",
      refrenceNmuber: "Referensnumber",
      image: "Company logotyp",
    },

    validation: {
      nameRequired: "YOU have to fill in company name",
      nameMax: "Company name must not be more than 255 chars",

      orgNumberRequired: "You have to fill in you compant VAT number",
      orgNumberFormatError: "Wrong format VAT number",

      emailRequired: "You have to fill in email address",
      emailFormatError: "Add valid email adress",

      passwordMissmatch: "Passwords does not match",
    },
  },

  user: {
    name: "User",
    email: "Email",
    role: "Role",
    userInfo: "Personal information",
    loginFailed: "Login failed",
    signInFailed: "Email/password does not match try again.",
    loginSuccessful: "Logged in ",
    updateFailed: "Update failed",
    edit: "Edit",
    forgotPassword: "Forgot password?",

    fields: {
      name: "Name",
      phoneNumber: "Phonenumber",
      email: "Email",
      password: "Password",
    },
  },

  validation: {
    required: "{0} must be filled in",
    max: "{0} mut be {1} charachters",
    requiredSingle: "This filed must be filled in",
    toLong: "This filed have to many characters",
    contryCodeError:
      "Dont forget that the phonumber must have countrycode (ex 4607xxxxxxxx)",
    passwordMissmatch: "Passwords does not match",
  },

  warning: {
    amount: "Activ Alarm:",
    notation: "{0} st",
  },
};
